import get from "lodash.get";

export const getUserAttributes = state => state.user;

export const getUserClientName = state => state.user.clientName;

export const getExternalIds = state => state.user.externalIds;

export const getCurrentExternalId = state => state.user.externalId;

export const getCompanyId = state =>
  JSON.parse(get(state, "oidc.user.profile", {})["user.organization"] || "{}")
    .Id;

export const getUserGhostingCompanies = state => state.ghosting.companies;

export const isGhosting = state => state.ghosting.isGhosting;

export const getGhostingCompany = state => state.ghosting.ghostingCompany;